import {Platform} from 'react-native';
import * as ExpoFileSystem from 'expo-file-system';
import {getById, writeItem} from './db';
import {
  _appendBuffer,
  checkFolderMobile,
  getFileReaderOpfs,
  saveFileToData,
  streamFile,
  writeFileOpfs,
} from './fs';
import {createBlobDB} from './blobdb';
import {Media} from '../types';
import {initNativeBlobMethods} from './util';

const rtcConfig: RTCConfiguration = {
  iceServers: [
    {
      urls: ['stun:turn.starpy.me', 'turn:turn.starpy.me'],
      username: 'username1',
      credential: 'password1',
    },
  ],
  sdpSemantics: 'unified-plan',
  bundlePolicy: 'max-bundle',
  iceCandidatePoolSize: 1,
  // iceTransportPolicy: 'relay',
};

let mediaClient: any, mediaWorker: any;
const announce = ['wss://media.starpy.me'];
const createMediaClient = async () => {
  const ops = {
    tracker: {
      rtcConfig,
      announce,
    },
    // secure:true,
    announce,
  };
  if (Platform.OS === 'web') {
    mediaClient = new WebTorrent(ops);
  } else {
    initNativeBlobMethods();

    const wt = (await import('webtorrent/dist/webtorrent.min.js'))
      .default;
    mediaClient = new wt(ops);
  }
  mediaClient.on('error', function (err) {
    console.error('mediaclient err: ' + err.message);
    // reject(err)
  });

  const resolveWorker = async reg => {
    const worker = reg.active || reg.waiting || reg.installing;
    await new Promise(resolvd2 => {
      const checkState = worker => {
        mediaWorker = worker;
        const res = worker.state === 'activated';
        if (res) {
          console.info('after load worker');
          mediaClient.loadWorker(worker, resolvd2);
        }
        return res;
      };
      if (!checkState(worker)) {
        mediaWorker.addEventListener('statechange', ({target}) =>
          checkState(target),
        );
      }
    });
  };
  const prs = await new Promise(async resolve => {
    if (Platform.OS === 'web') {
      const reg = await navigator.serviceWorker.register(
        '/sw.min.js',
      );
      const wp = await resolveWorker(reg);
    } else {
      return resolve(mediaClient);
    }
  });
  return prs;
};
createMediaClient();
export const downloadFileById = async (
  mediaId: string,
  folderId?: string,
  progressCB?: (progress: number) => void,
  doneCB?: () => void,
) => {
  return new Promise(async (rs, rej) => {
    try {
      const media: Media = await getById(mediaId, folderId);
      if (media?.extractor === 'wt') {
        let wt;
        let stream: string | undefined;
        if (mediaClientFiles[mediaId]) {
          wt = mediaClientFiles[mediaId];
        } else {
          const mediaData = await getVideoWT(media);
          wt = mediaData.torrent;
          stream = mediaData.stream;
        }
        let prevProgress = 0;
        // let progressTimeout = undefined
        wt.on('download', bytes => {
          // console.info('wt.progress', wt.progress)
          const nextProgress = parseInt(wt.progress * 100, 10) / 100;
          if (progressCB && nextProgress > prevProgress) {
            // clearTimeout(progressTimeout)
            prevProgress = nextProgress;
            progressCB(nextProgress);
          }
        });
        wt.on('done', async () => {
          if (Platform.OS === 'web') {
            stream = await mobileStreamingForFileIsRunning[mediaId];
            const blob = await (await fetch(stream)).arrayBuffer();
            console.info('blob from stream', blob, media, stream);
            const file = new File([blob], media.filename);
            const fsr = await writeFileOpfs(media, file);
            if (doneCB) doneCB();
            return rs(fsr);
          } else {
            stream = await mobileStreamingForFileIsRunning[mediaId];
            console.info('wt done fetch from stream: ' + stream);
          }
        });
      }
    } catch (err) {
      console.error('download file error', err);
      rej(err);
    }
  });
};

export const downloadFileByMedia = async (
  media: Media,
  progressCB?: (progress: number) => void,
) => {
  const mediaId = media.id;
  if (media?.extractor === 'wt') {
    // const wt = await getVideoWT(media);
    let wt;
    let stream;
    let cbt = null;
    // if (wt) {
    if (mediaClientFiles[mediaId]) {
      wt = mediaClientFiles[mediaId];
    } else {
      const mediaData = await getVideoWT(media);
      wt = mediaData.torrent;
      stream = mediaData.stream;
    }
    wt.on('download', bytes => {
      if (progressCB) progressCB(wt.progress);
    });
    if (Platform.OS === 'web') {
      const blob = await (await fetch(stream)).arrayBuffer();
      const file = new File([blob], media.filename);
      return await writeFileOpfs(media, file);
    }
  }
};

const isVideo = (file: any) =>
  file?.name?.endsWith('.mp4') ||
  file?.name?.endsWith('.webm') ||
  file?.name?.endsWith('.mkv') ||
  file?.name?.endsWith('.mov');

const mediaClientFiles = {};
const streamUrls: {[key: string]: string | undefined} = {};
const mobileStreamingForFileIsRunning: {
  [key: string]: Promise<string | undefined> | undefined;
} = {};
const processWT = async (
  wt,
  media: Media,
  filename?: string,
): Promise<string | undefined> => {
  let file = filename
    ? wt.files.find(i => i.name || i.filename === filename)
    : wt.files.find(file => isVideo(file));

  if (!file && wt.files?.length) file = wt.files[0];

  if (streamUrls[media.id]) return streamUrls[media.id];

  if (mobileStreamingForFileIsRunning[media.id])
    return await mobileStreamingForFileIsRunning[media.id];

  if (!file?.name) throw new Error('no_file_found_in_metadata');

  console.info('file name found', file?.name);

  mobileStreamingForFileIsRunning[media.id] = new Promise(
    async (resolve, reject) => {
      try {
        const process = (err: Error, url: string) => {
          if (err) return reject(err);
          resolve(url);
        };
        // isVideo(file) ?
        if (Platform.OS === 'web') {
          file?.getStreamURL(process);
        } else {
          const dirPath = `${ExpoFileSystem.documentDirectory}${media.folderId}`;
          await checkFolderMobile(dirPath);
          const fileUri = `${dirPath}/${file.name}`;
          await ExpoFileSystem.writeAsStringAsync(fileUri, '', {
            encoding: 'base64',
          });
          file.select();
          const {writeBlob} = await createBlobDB();
          const stream = file.createReadStream();
          let countChunks = 0;
          let lastSave = 0;
          // const saveThreshold = 5;
          // const startTheshold = 70;
          let saveCount = 0;
          stream.on('data', (chunk: Uint8Array) => {
            countChunks++;
            const chunkId = parseInt(countChunks.toString(), 10);
            console.info('writing chunk', chunkId);
            writeBlob(file.name, chunk).then(() => {
              try {
                if (lastSave !== chunkId) {
                  lastSave = countChunks;
                  saveCount++;
                  saveFileToData(file.name, fileUri, saveCount).then(
                    () => {
                      // if (startTheshold >= saveCount)
                      //   resolve(fileUri);
                    },
                  );
                }
              } catch (err) {
                console.error('write blob err', err);
              }
            });
          });

          file.on('done', async () => {
            console.info('file done', file.name);
            saveCount++;
            await saveFileToData(file.name, fileUri, saveCount);
            resolve(fileUri);
          });
        }
      } catch (err) {
        mobileStreamingForFileIsRunning[media.id] = undefined;
        console.error('get stream err', err);
      }
    },
  ).catch(err => {
    mobileStreamingForFileIsRunning[media.id] = undefined;
    console.error('get stream url error', err);
  }) as Promise<string | undefined>;

  streamUrls[file.name] = await mobileStreamingForFileIsRunning[
    file.name
  ];
  console.info('after stream url', streamUrls[file.name]);
  return streamUrls[file.name];
};

export const getVideoWT = async (
  media: Media,
  filename?: string,
): Promise<{stream: string | undefined; torrent: any}> => {
  return new Promise(async (resolve, reject) => {
    try {
      if (mediaClientFiles[media.id]) {
        resolve({
          stream: await processWT(
            mediaClientFiles[media.id],
            media,
            filename,
          ),
          torrent: mediaClientFiles[media.id],
        });
        return;
      }
      // console.info('before media client add', media.filename, );
      const torrentFileName = 'torrent.file.' + media.id;
      const torrentBuffer =
        media?.torrentFile && Platform.OS === 'web'
          ? new File(
              [
                Uint8Array.from(Object.values(media.torrentFile))
                  .buffer,
              ],
              torrentFileName,
            )
          : media?.torrentFile &&
            Uint8Array.from(Object.values(media.torrentFile));
      // if(torrentBuffer)
      //   torrentBuffer.name = torrentFileName

      console.info('torrentFile', torrentBuffer);

      mediaClient.add(torrentBuffer || media.url, wt => {
        try {
          mediaClientFiles[media.id] = wt;
          console.info('after mediaclient add', media.filename, wt);
          processWT(wt, media, filename)
            .then(streamUrl =>
              resolve({stream: streamUrl, torrent: wt}),
            )
            .catch(err => reject(err));
        } catch (err) {
          console.error('getVideoWT err', err);
          reject(err);
        }
      });
    } catch (err) {
      console.error('get video wt err', err);
      reject(err);
    }
  });
};

export const getWT = async (magnet: string): Promise<any> => {
  return await new Promise(async (resolve, reject) => {
    mediaClient.add(magnet, async wt => resolve(wt));
  });
};

const isSharing: {[key: string]: true | undefined} = {};
export const shareFileToWT = async (
  mediaId: string,
  folderId?: string,
) => {
  try {
    const media: Media = await getById(mediaId, folderId);
    if (
      (media.infoHash && isSharing[media.infoHash]) ||
      isSharing[mediaId]
    ) {
      console.info('issharing already', isSharing);
      return;
    }
    if (media.infoHash) isSharing[media.infoHash] = true;
    isSharing[mediaId] = true;

    let file = await getFileReaderOpfs(media);
    console.info('filepath', file);
    if (Platform.OS !== 'web') {
      // const bs64 = await ExpoFileSystem.readAsStringAsync(
      //   file as string,
      //   {encoding: 'base64'},
      // );
      // file = `data:${media.fileType || "video/mp4"};base64,${bs64}`
      const fileDL = file?.toString(); //.replace('file://', '');
      // file = await (await fetch(fileDL)).blob()
      file = new Blob([], {type: media.fileType, size: media.size});
      const stream = streamFile(
        fileDL,
        0,
        5000,
        media.size as number,
      );
      stream.length = media.size;
      file.length = media.size;
      // file.size = media.size
      // file.stream = () => fsd.body;
      file.stream = () => stream;
      file.name = media.filename;
      // file = arrayBuffer;
      // file = new File(arrayBuffer, media.filename);
    }
    console.info('share file wt', file);
    if (!file) throw 'no_file';
    // if(Platform.OS === "web")
    return shareFile(file, announce, media);
    // return runOnRuntime(bgRuntime, shareFile)(file, announce, media)
  } catch (err) {
    console.error('shareFileToWt err', err);
  }
};
const onProgress = progress => {
  // console.info('ontorrentcreateprogress', progress)
};
const shareFile = (
  file: File | string,
  announce: string[],
  media: Media,
) => {
  'worklet';
  return new Promise((resolve, reject) => {
    try {
      mediaClient.seed(file, {announce, onProgress}, async wt => {
        try {
          console.info('after wt create', wt);
          if (media.torrentFile) return resolve(media);
          media.torrentFile = wt.torrentFile;
          media.url = wt.magnetURI;
          media.infoHash = wt.infoHash;
          media.extractor = 'wt';
          media.isDownloaded = true;

          await writeItem(media);
          resolve(media as Media);
        } catch (err) {
          console.error('create wt err', err);
          reject(err);
        }
      });
    } catch (err) {
      console.error('create wt err', err);
      reject(err);
    }
  });
};
